import { CPF_DIGITS_LENGTH } from "../utils/documentFormat"

export const INPUT_SIZE = {
  PROMOTIONS: {
    name: 45,
    description: 200,
    fixedValue: 10,
    percentage: 3,
  },
  MEALS: {
    name: 45,
    description: 200,
    value: 10,
  },
  TABLE: {
    number: 10,
    description: 200,
  },
  EXTRA_SERVICE: {
    name: 45,
    description: 200,
    value: 10,
  },
  AWARD: {
    name: 45,
    countToWin: 10,
    minimumValue: 10,
    description: 200,
    valueDiscountWhenWon: 10,
    valueDiscountWhenWonPercent: 3,
  },
  REFERRAL: {
    name: 50,
    code: 20,
  },
  ADMIN_PLAN: {
    name: 100,
    description: 500,
  },
  ADMIN_PLAN_COUPON: {
    code: 30,
  },
  COMPANY: {
    url: 50,
    name: 45,
    socialReason: 45,
    publicMessage: 200,
    cnpj: 20,
    stateInscrition: 45,
    socialUrl: 250,
    trackingId: 30,
    whatsappPhone: 20,
    whatsappOrderTemplate: 500,
  },
  EMPLOYEE: {
    position: 20,
    salary: 8,
    comission: 10,
    password: 15,
    mail: 50,
    userName: 50,
  },
  PERSON: {
    name: 45,
    cpf: CPF_DIGITS_LENGTH,
    rg: 10,
    phone: 15,
    email: 45,
    dateBorn: 10,
  },
  ORDER: {
    cancelMotion: 200,
    genericMealDetails: 200,
  },
  SINGUP: {
    name: 100,
    companyName: 100,
    cnpj: 14,
    mail: 50,
    password: 20,
  },
}
